const authorFromScratch = {
  topicId: "nualang.author-from-scratch.0.0.1",
  topicName: "Údar ó Scratch",
  description: "",
  difficulty: "ALL",
  learnLang: "irish",
};

export default authorFromScratch;
